import React from "react";

//UI Material
import { Button, TableCell, TableRow, Typography } from "@mui/material";

//Material Icons
import { ArrowForwardIos } from "@mui/icons-material";

export default function StockoutRow({ stockoutData }) {
  return (
    <TableRow>
      <TableCell align="center" sx={{ maxWidth: "200px" }}>
        <Typography variant="body2">{stockoutData.id}</Typography>
      </TableCell>
      <TableCell align="center" sx={{ maxWidth: "200px" }}>
        <Typography variant="body2">{stockoutData.itemId}</Typography>
      </TableCell>
      <TableCell align="center" sx={{ maxWidth: "200px" }}>
        <Typography variant="body2">{stockoutData.name}</Typography>
      </TableCell>
      <TableCell align="center" sx={{ maxWidth: "200px" }}>
        <Typography variant="body2">
          {new Date(stockoutData.createdAt).toLocaleString()}
        </Typography>
      </TableCell>
      <TableCell align="center" sx={{ maxWidth: "200px" }}>
        <Typography variant="body2">
          {Number(stockoutData.quantity).toFixed(2)}
        </Typography>
      </TableCell>
      <TableCell align="center" sx={{ maxWidth: "200px" }}>
        <Typography variant="body2">{stockoutData.reason}</Typography>
      </TableCell>
      <TableCell align="center" sx={{ maxWidth: "200px" }}>
        <Button
          size="small"
          color="secondary"
          variant="contained"
          sx={{ color: "white" }}
          endIcon={<ArrowForwardIos />}
          onClick={() => {
            window.location.href = `/stockout?id=${stockoutData.id}`;
          }}
        >
          Ver detalles
        </Button>
      </TableCell>
    </TableRow>
  );
}
